
// // src/components/Chatbot.js
// import React, { useState, useEffect } from 'react';
// import { 
//   Dialog, DialogContent, IconButton, useMediaQuery, 
//   Box, Typography, TextField, Button, Autocomplete, 
//   Collapse, Avatar, Tooltip 
// } from '@mui/material';
// import { styled, useTheme } from '@mui/material/styles';
// import Draggable from 'react-draggable';
// import ChatbotIcon from '@mui/icons-material/SmartToy';
// import CloseIcon from '@mui/icons-material/Close';
// import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
// import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
// import SendIcon from '@mui/icons-material/Send';
// import axios from 'axios';
// import apiClient from '../utils/apiClient';

// // A styled DraggableIcon for the floating button
// const DraggableIcon = styled('div')(({ theme }) => ({
//   position: 'fixed',
//   zIndex: 1000,
//   cursor: 'move',
// }));
// // A styled container for messages
// const MessageContainer = styled('div')(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   overflowY: 'auto',
//   flexGrow: 1,
//   padding: theme.spacing(2),
//   backgroundColor: theme.palette.grey[100],
//   borderRadius: theme.shape.borderRadius,
// }));
// const MessageBubble = styled('div')(({ theme, role }) => ({
//   maxWidth: '80%',
//   marginBottom: theme.spacing(2),
//   padding: theme.spacing(1.5),
//   borderRadius: theme.shape.borderRadius,
//   display: 'flex',
//   alignItems: 'flex-start',
//   ...(role === 'assistant' ? {
//     alignSelf: 'flex-start',
//     backgroundColor: theme.palette.background.paper,
//   } : {
//     alignSelf: 'flex-end',
//     backgroundColor: theme.palette.primary.light,
//     color: theme.palette.primary.contrastText,
//   }),
// }));
// const MessageText = styled(Typography)({
//   wordWrap: 'break-word',
// });
// // A bottom input area similar to ChatGPT's style
// const InputArea = styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(1),
//   borderTop: `1px solid ${theme.palette.divider}`,
//   backgroundColor: theme.palette.background.default,
// }));
// function Chatbot() {
//   const theme = useTheme();
//   const [open, setOpen] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState('');
//   const [sessionId, setSessionId] = useState('');
//   const [query, setQuery] = useState('');
//   const [chatHistory, setChatHistory] = useState([]);
//   const [citations, setCitations] = useState([]);
//   const [showCitations, setShowCitations] = useState(false);
//   const isMobile = useMediaQuery('(max-width:600px)');
//   const initialPosition = {
//     x: isMobile ? window.innerWidth - 80 : window.innerWidth - 80,
//     y: isMobile ? window.innerHeight - 150 : window.innerHeight - 150,
//   };
//   const handleChatToggle = async () => {
//     setOpen(!open);
//     if (!open) {
//       // Reset states when opening
//       setSessionId('');
//       setSelectedProduct('');
//       setChatHistory([]);
//       setCitations([]);
//       setShowCitations(false);
//       // Fetch product list
//       try {
//         // const resp = await axios.get('http://localhost:8000/api/chatbot/products');
//         const resp = await apiClient.post('/products');
//         setProducts(resp.data.products);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   };
//   const startSession = async () => {
//     if (!selectedProduct) return;
//     try {
//       // const resp = await axios.post('http://localhost:8000/api/chatbot/session', { product: selectedProduct });
//       const resp = await apiClient.post('/session', { product: selectedProduct });
//       setSessionId(resp.data.session_id);
//       setChatHistory([]);
//       setCitations([]);
//       setShowCitations(false);
//     } catch (err) {
//       console.error(err);
//     }
//   };
//   const sendMessage = async () => {
//     if (!query || !sessionId) return;
//     const userQuery = query;
//     setQuery('');
//     setChatHistory(prev => [...prev, { role: 'user', text: userQuery }]);
//     try {
//       // const resp = await axios.post('http://localhost:8000/api/chatbot/message', {
//       const resp = await apiClient.post('/message', {
//         session_id: sessionId,
//         query: userQuery,
//       });
//       setChatHistory(prev => [...prev, { role: 'assistant', text: resp.data.answer }]);
//       setCitations(resp.data.citations || []);
//       setShowCitations(false);
//     } catch (err) {
//       console.error(err);
//     }
//   };
//   const sendFeedback = async (feedbackType) => {
//     if (!sessionId || !selectedProduct) return;
//     const lastUserMsg = chatHistory.filter(m => m.role === 'user').slice(-1)[0];
//     const lastBotMsg = chatHistory.filter(m => m.role === 'assistant').slice(-1)[0];
//     if (!lastUserMsg || !lastBotMsg) return;
//     try {
//       // await axios.post('http://localhost:8000/api/chatbot/feedback', {
//       await apiClient.post('/feedback', {
//         session_id: sessionId,
//         query: lastUserMsg.text,
//         response: lastBotMsg.text,
//         feedback: feedbackType,
//         product: selectedProduct,
//       });
//       alert("Feedback stored successfully");
//     } catch (err) {
//       console.error(err);
//     }
//   };
//   const handleProductChange = (event, value) => {
//     // If user changes product mid-session, prompt a new session start
//     setSelectedProduct(value);
//   };
//   const handleStartChatButton = () => {
//     if (sessionId && selectedProduct) {
//       // Already in a session, changing product means start a new session
//       // Confirm if needed
//       if (window.confirm("Changing the product will start a new session. Continue?")) {
//         startSession();
//       }
//     } else {
//       startSession();
//     }
//   };
//   return (
//     <>
//       <Draggable
//         bounds="parent"
//         defaultPosition={{ x: initialPosition.x, y: initialPosition.y }}
//       >
//         <DraggableIcon>
//           <IconButton
//             color="secondary"
//             aria-label="chatbot"
//             onClick={handleChatToggle}
//             sx={{
//               backgroundColor: 'primary.main',
//               color: '#fff',
//               '&:hover': {
//                 backgroundColor: 'primary.dark',
//               },
//               width: 56,
//               height: 56,
//               boxShadow: theme.shadows[4],
//             }}
//           >
//             <ChatbotIcon fontSize="large" />
//           </IconButton>
//         </DraggableIcon>
//       </Draggable>
//       <Dialog 
//         open={open} 
//         onClose={handleChatToggle} 
//         fullWidth 
//         maxWidth="md"
//         PaperProps={{ style: { height: '80vh', display: 'flex', flexDirection: 'column' } }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', p: 2, borderBottom: `1px solid ${theme.palette.divider}`, justifyContent: 'space-between' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <ChatbotIcon fontSize="large" color="primary"/>
//             <Autocomplete
//               options={products}
//               value={selectedProduct || null}
//               onChange={handleProductChange}
//               renderInput={(params) => <TextField {...params} label="Select or search product" variant="outlined" size="small" />}
//               sx={{ width: 300 }}
//             />
//             <Button 
//               variant="contained" 
//               color="secondary" 
//               onClick={handleStartChatButton}
//               disabled={!selectedProduct}
//             >
//               {sessionId ? "New Session" : "Start Chat"}
//             </Button>
//           </Box>
//           <IconButton
//             aria-label="close"
//             onClick={handleChatToggle}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
        
//         <DialogContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 0 }}>
//           <MessageContainer>
//             {chatHistory.map((msg, index) => (
//               <MessageBubble key={index} role={msg.role}>
//                 <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
//                   {msg.role === 'assistant' ? (
//                     <Tooltip title="Chatbot">
//                       <Avatar sx={{ bgcolor: theme.palette.grey[300] }}>
//                         <ChatbotIcon fontSize="small"/>
//                       </Avatar>
//                     </Tooltip>
//                   ) : (
//                     <Tooltip title="You">
//                       <Avatar sx={{ bgcolor: theme.palette.primary.main }}>Y</Avatar>
//                     </Tooltip>
//                   )}
//                   <MessageText variant="body1">{msg.text}</MessageText>
//                 </Box>
//               </MessageBubble>
//             ))}
//           </MessageContainer>
//           {/* Citations and feedback at the bottom of the last assistant message */}
//           {chatHistory.some(m => m.role === 'assistant') && (
//             <Box sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}`, display: 'flex', flexDirection: 'column', gap: 1 }}>
//               {citations.length > 0 && (
//                 <>
//                   <Button variant="text" onClick={() => setShowCitations(!showCitations)}>
//                     {showCitations ? "Hide Citations" : "Show Citations"}
//                   </Button>
//                   <Collapse in={showCitations}>
//                     <Box sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1, maxHeight: 150, overflowY: 'auto' }}>
//                       {citations.map((c, i) => (
//                         <Typography key={i} variant="body2" sx={{ mb: 1 }}>Citation-{i+1}: {c.trim('#')}</Typography>
//                       ))}
//                     </Box>
//                   </Collapse>
//                 </>
//               )}
//               <Box sx={{ display: 'flex', gap: 1 }}>
//                 <Button
//                   variant="outlined"
//                   startIcon={<ThumbUpAltOutlinedIcon />}
//                   onClick={() => sendFeedback('thumbs_up')}
//                 >
//                   Thumbs Up
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   startIcon={<ThumbDownAltOutlinedIcon />}
//                   onClick={() => sendFeedback('thumbs_down')}
//                 >
//                   Thumbs Down
//                 </Button>
//               </Box>
//             </Box>
//           )}
//           {/* Input area */}
//           {sessionId && (
//             <InputArea>
//               <TextField
//                 fullWidth
//                 placeholder="Enter your question..."
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 onKeyDown={(e) => { if (e.key === 'Enter') sendMessage(); }}
//                 variant="outlined"
//                 size="small"
//               />
//               <IconButton color="primary" onClick={sendMessage} disabled={!query.trim()}>
//                 <SendIcon />
//               </IconButton>
//             </InputArea>
//           )}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// }
// export default Chatbot;


// src/components/Chatbot.js this is the version with filter, attachments and default questions
import React, { useState, useEffect, useContext } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  Box,
  Typography,
  TextField,
  Button,
  Autocomplete,
  DialogTitle,
  Popover,
  Tooltip,
  Card,
  Grid,
  Collapse,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import Draggable from 'react-draggable';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// Icons
import ChatbotIcon from '@mui/icons-material/SmartToy';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import SendIcon from '@mui/icons-material/Send';
import FilterListIcon from '@mui/icons-material/FilterList';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// Networking
import axios from 'axios';
// (Optional) If you have some local data for advanced logic:
import chatbotMapping from '../data/chatbot_product_card_con.json';
import productFrontend from '../data/product_frontend.json';
import apiClient from '../utils/apiClient';
import { UserContext } from '../context/UserContext';
/** Minimal icon mapping for attachments. */
function getIconForLabel(label) {
  switch (label) {
    case 'brochure':
    case 'product_ppt':
    case 'terms_and_conditions':
    case 'one_pager':
      return <AttachFileIcon fontSize="small" />;
    default:
      return null;
  }
}
const DraggableIcon = styled('div')(({ theme }) => ({
  position: 'fixed',
  zIndex: 1000,
  cursor: 'move',
}));
const MessageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  flexGrow: 1,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
}));
const MessageBubble = styled('div')(({ theme, role }) => ({
  maxWidth: '80%',
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'flex-start',
  ...(role === 'assistant'
    ? {
        alignSelf: 'flex-start',
        backgroundColor: theme.palette.background.paper,
      }
    : {
        alignSelf: 'flex-end',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      }),
}));
const MessageText = styled(Typography)(() => ({
  wordWrap: 'break-word',
}));
const InputArea = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(1),
}));
/**
 * Map product names to category groups.
 * Extend or modify as needed. Unknown product => 'General'
 */
const categoryMapping = {
  Signature: 'Retirement',
  Platinum: 'ULIP',
  // e.g. "Anmol Bachat": "Traditional",
  // etc...
};
function getCategoryForProduct(productName) {
  return categoryMapping[productName] || 'General';
}
function Chatbot() {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');
  // Draggable icon initial position
  const initialPosition = {
    x: isMobile ? window.innerWidth - 80 : window.innerWidth - 80,
    y: isMobile ? window.innerHeight - 150 : window.innerHeight - 150,
  };
  // States
  const [open, setOpen] = useState(false);
  // We'll store the raw product list from your API as strings:
  const [allProducts, setAllProducts] = useState([]); // unfiltered
  const [filteredProducts, setFilteredProducts] = useState([]); // after category filter
  const [selectedProduct, setSelectedProduct] = useState(''); // string
  const [sessionId, setSessionId] = useState('');
  const [query, setQuery] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [citations, setCitations] = useState([]);
  // Popups for attachments, citations, and feedback
  const [attachmentsDialogOpen, setAttachmentsDialogOpen] = useState(false);
  const [citationsDialogOpen, setCitationsDialogOpen] = useState(false);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  // For collapsing default questions
  const [showDefaultQuestions, setShowDefaultQuestions] = useState(true);
  // For product details (AEM links, etc.)
  const [productDetails, setProductDetails] = useState(null);
  // Filter popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  // Some default Q&A suggestions
  const defaultQuestions = [
    'Product boundary conditions',
    'Key features',
    'Payout options',
    'Tax benefits',
    'Policy Term',
  ];
  // 1) Toggle open/close the entire chatbot
  const handleChatToggle = async () => {
    setOpen(!open);
    if (!open) {
      // Reset everything upon opening
      setSessionId('');
      setSelectedProduct('');
      setChatHistory([]);
      setCitations([]);
      setAttachmentsDialogOpen(false);
      setCitationsDialogOpen(false);
      setFeedbackDialogOpen(false);
      setProductDetails(null);
      // Fetch product list from your backend (returns string array).
      try {
        const resp = await apiClient.post('/products', { ntID: userNTID });
        const productList = resp.data.products || [];
        setAllProducts(productList);
        setFilteredProducts(productList);
        // Build category set from the mapping:
        // For each product in the list, figure out its category
        const cats = new Set();
        productList.forEach((p) => {
          cats.add(getCategoryForProduct(p));
        });
        setAvailableCategories(Array.from(cats));
      } catch (err) {
        console.error(err);
      }
    }
  };
  // 2) Start a new session
  const startSession = async () => {
    if (!selectedProduct) return;
    try {
      const resp = await apiClient.post('/session', {
        ntID: userNTID,
        product: selectedProduct, // e.g. "Signature"
        user_id: userNTID,
        source: 'chatbot'
      });
      console.log("RESPONSEEEE---->", resp);

      setSessionId(resp.data.session_id);
      setChatHistory([]);
      setCitations([]);
      setAttachmentsDialogOpen(false);
      setCitationsDialogOpen(false);
      setFeedbackDialogOpen(false);
      loadProductDetails(selectedProduct);
    } catch (err) {
      console.error(err);
    }
  };
  // 2a) Load AEM details if any exist
  const loadProductDetails = async (prodName) => {
    try {
      // Look up the ID in chatbotMapping
      const mappingRow = chatbotMapping.find(
        (item) => item.ChatbotProductName === prodName
      );
      if (!mappingRow) {
        setProductDetails(null);
        return;
      }
      const neededId = String(mappingRow.product_json_ID);
      // Then find the front-end details row
      const frontendRow = productFrontend.find(
        (p) => p.product_json_ID === neededId
      );
      if (!frontendRow) {
        setProductDetails(null);
        return;
      }
      // Finally fetch from AEM (your existing endpoint)
      const aemUrl = frontendRow.PRODUCT_DETAILS_AEM_URL;
      const detailsResp = await apiClient.post(`/productAemDetails`, { ntID: userNTID }, {
        params: {
          url: aemUrl}});
      if (detailsResp.status !== 200) {
        console.error('AEM fetch failed:', detailsResp.status);
        setProductDetails(null);
        return;
      }
      const d = detailsResp.data;
      const finalObj = {
        product_logo: d.product_logo || null,
        product_name: d.product_name || prodName,
        brochure: d.brochure || '',
        product_ppt: d.product_ppt || '',
        one_pager: d.one_pager || '',
        terms_and_conditions: d.terms_and_conditions || '',
      };
      setProductDetails(finalObj);
    } catch (err) {
      console.error('Error loading AEM details:', err);
      setProductDetails(null);
    }
  };
  // 3) Send message
  const sendMessage = async (overrideText) => {
    const msg = overrideText || query;
    if (!msg || !sessionId) return;
    setQuery('');
    setChatHistory((prev) => [...prev, { role: 'user', text: msg }]);
    try {
      const resp = await apiClient.post('/message', {
        ntID: userNTID,
        user_id: userNTID,
        session_id: sessionId,
        query: msg,
      });
      setChatHistory((prev) => [
        ...prev,
        { role: 'assistant', text: resp.data.answer },
      ]);
      setCitations(resp.data.citations || []);
      setAttachmentsDialogOpen(false);
      setCitationsDialogOpen(false);
      setFeedbackDialogOpen(false);
    } catch (err) {
      console.error(err);
    }
  };
  // 4) Feedback
  const sendFeedback = async (feedbackType) => {
    if (!sessionId || !selectedProduct) return;
    const lastUserMsg = chatHistory.filter((m) => m.role === 'user').slice(-1)[0];
    const lastBotMsg = chatHistory.filter((m) => m.role === 'assistant').slice(-1)[0];
    if (!lastUserMsg || !lastBotMsg) return;
    try {
      await apiClient.post('/feedback', {
        ntID: userNTID,
        user_id: userNTID,
        session_id: sessionId,
        query: lastUserMsg.text,
        response: lastBotMsg.text,
        feedback: feedbackType,
        product: selectedProduct,
        
      });
      alert('Feedback stored successfully');
    } catch (err) {
      console.error(err);
    }
  };
  // Handle changes in the product Autocomplete
  const handleProductChange = (e, newValue) => {
    if (newValue) {
      setSelectedProduct(newValue);
    } else {
      setSelectedProduct('');
    }
  };
  // Start/New session button
  const handleStartChatButton = () => {
    if (sessionId && selectedProduct) {
      if (window.confirm('Changing the product will start a new session. Continue?')) {
        startSession();
      }
    } else {
      startSession();
    }
  };
  // If user presses Enter in the textfield
  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };
  // For default question buttons
  const handleDefaultQuestionClick = (question) => {
    sendMessage(question);
  };
  // Filter popover
  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
  };
  const openFilterPopover = Boolean(anchorEl);
  // Updating the filtered products if selectedCategories changes
  useEffect(() => {
    if (selectedCategories.length === 0) {
      // No filter => show all
      setFilteredProducts(allProducts);
    } else {
      // Filter by category
      const newList = allProducts.filter((prod) =>
        selectedCategories.includes(getCategoryForProduct(prod))
      );
      setFilteredProducts(newList);
    }
  }, [selectedCategories, allProducts]);
  // Handle toggling a category
  const handleCategoryChange = (cat) => {
    let updated = [...selectedCategories];
    if (updated.includes(cat)) {
      updated = updated.filter((c) => c !== cat);
    } else {
      updated.push(cat);
    }
    setSelectedCategories(updated);
  };
  return (
    <>
      {/* Draggable Chatbot Icon */}
      <Draggable bounds="parent" defaultPosition={{ x: initialPosition.x, y: initialPosition.y }}>
        <DraggableIcon>
          <IconButton
            color="secondary"
            aria-label="chatbot"
            onClick={handleChatToggle}
            sx={{
              backgroundColor: 'primary.main',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
              width: 56,
              height: 56,
              boxShadow: theme.shadows[4],
            }}
          >
            <ChatbotIcon fontSize="large" />
          </IconButton>
        </DraggableIcon>
      </Draggable>
      <Dialog
        open={open}
        onClose={handleChatToggle}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: 2,
            borderBottom: `1px solid ${theme.palette.divider}`,
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ChatbotIcon fontSize="large" color="primary" />
            {/* Autocomplete with product array (strings) */}
            <Autocomplete
              options={filteredProducts}
              value={selectedProduct || null}
              onChange={handleProductChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select or search product"
                  variant="outlined"
                  size="small"
                />
              )}
              sx={{ width: 300 }}
            />
            {/* Filter Icon */}
            <IconButton onClick={handleFilterClick} color="primary" size="small">
              <FilterListIcon />
            </IconButton>
            <Popover
              open={openFilterPopover}
              anchorEl={anchorEl}
              onClose={handleFilterClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Box sx={{ p: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Filter by Category
                </Typography>
                <FormGroup>
                  {availableCategories.map((cat) => (
                    <FormControlLabel
                      key={cat}
                      control={
                        <Checkbox
                          checked={selectedCategories.includes(cat)}
                          onChange={() => handleCategoryChange(cat)}
                        />
                      }
                      label={cat}
                    />
                  ))}
                </FormGroup>
              </Box>
            </Popover>
            {/* Start / New Session */}
            <Button
              variant="contained"
              color="secondary"
              onClick={handleStartChatButton}
              disabled={!selectedProduct}
            >
              {sessionId ? 'New Session' : 'Start Chat'}
            </Button>
            {/* New Icons for Attachments, Citations, and Feedback */}
            {sessionId && (
              <Box sx={{ display: 'flex', gap: 1 }}>
                {productDetails && (
                  <Tooltip title="Attachments">
                    <IconButton onClick={() => setAttachmentsDialogOpen(true)} color="primary">
                      <AttachFileIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {citations.length > 0 && (
                  <Tooltip title="Citations">
                    <IconButton onClick={() => setCitationsDialogOpen(true)} color="primary">
                      <MenuBookIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {chatHistory.some((m) => m.role === 'assistant') && (
                  <Tooltip title="Feedback">
                    <IconButton onClick={() => setFeedbackDialogOpen(true)} color="primary">
                      <FeedbackIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          </Box>
          <IconButton aria-label="close" onClick={handleChatToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
        {/* Main Content */}
        <DialogContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 0 }}>
          {/* Chat History */}
          <MessageContainer>
            {chatHistory.map((msg, i) => (
              <MessageBubble key={i} role={msg.role}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                  {msg.role === 'assistant' ? (
                    <Tooltip title="Chatbot">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton size="small" sx={{ p: 0, bgcolor: theme.palette.grey[300] }}>
                          <ChatbotIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Tooltip>
                  ) : (
                    <Tooltip title="You">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton size="small" sx={{ p: 0, bgcolor: theme.palette.primary.main }}>
                          <Typography variant="caption" sx={{ color: '#fff' }}>Y</Typography>
                        </IconButton>
                      </Box>
                    </Tooltip>
                  )}
                  <MessageText variant="body1">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.text}</ReactMarkdown>
                  </MessageText>
                </Box>
              </MessageBubble>
            ))}
          </MessageContainer>
          {/* Bottom UI */}
          {sessionId && (
            <Box sx={{ borderTop: `1px solid ${theme.palette.divider}`, p: 1 }}>
              {/* Toggle for Default Questions */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle2">Choose from the following FAQ's or Type your own query</Typography>
                <IconButton size="small" onClick={() => setShowDefaultQuestions((prev) => !prev)}>
                  {showDefaultQuestions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={showDefaultQuestions} timeout="auto" unmountOnExit>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                  {defaultQuestions.map((dq, i) => (
                    <Button
                      key={i}
                      variant="outlined"
                      size="small"
                      onClick={() => handleDefaultQuestionClick(dq)}
                      sx={{ fontSize: '0.75rem', padding: '4px 8px' }}
                    >
                      {dq}
                    </Button>
                  ))}
                </Box>
              </Collapse>
              {/* Query textfield + send */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField
                  fullWidth
                  placeholder="Enter your question..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={handleEnterKey}
                  variant="outlined"
                  size="small"
                />
                <IconButton color="primary" onClick={() => sendMessage()} disabled={!query.trim()}>
                  <SendIcon />
                </IconButton>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      {/* Attachments Popup */}
      <Dialog open={attachmentsDialogOpen} onClose={() => setAttachmentsDialogOpen(false)}>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Attachments</Typography>
            <IconButton onClick={() => setAttachmentsDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          {productDetails && (
            <Card
              sx={{
                mt: 1,
                p: 2,
                backgroundColor: '#f0f0f0',
                borderRadius: 2,
                maxWidth: 350,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                {productDetails.product_logo && (
                  <img
                    src={productDetails.product_logo}
                    alt={productDetails.product_name}
                    style={{
                      width: '50px',
                      height: '50px',
                      objectFit: 'contain',
                      marginRight: '8px',
                    }}
                  />
                )}
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {productDetails.product_name}
                </Typography>
              </Box>
              <Grid container spacing={1}>
                {productDetails.brochure && (
                  <Grid item>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={getIconForLabel('brochure')}
                      onClick={() => window.open(productDetails.brochure, '_blank')}
                    >
                      Brochure
                    </Button>
                  </Grid>
                )}
                {productDetails.product_ppt && (
                  <Grid item>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={getIconForLabel('product_ppt')}
                      onClick={() => window.open(productDetails.product_ppt, '_blank')}
                    >
                      PPT
                    </Button>
                  </Grid>
                )}
                {productDetails.one_pager && (
                  <Grid item>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={getIconForLabel('one_pager')}
                      onClick={() => window.open(productDetails.one_pager, '_blank')}
                    >
                      One Pager
                    </Button>
                  </Grid>
                )}
                {productDetails.terms_and_conditions && (
                  <Grid item>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={getIconForLabel('terms_and_conditions')}
                      onClick={() =>
                        window.open(productDetails.terms_and_conditions, '_blank')
                      }
                    >
                      T&C
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Card>
          )}
        </Box>
      </Dialog>
      {/* Citations Popup */}
      <Dialog open={citationsDialogOpen} onClose={() => setCitationsDialogOpen(false)}>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Citations</Typography>
            <IconButton onClick={() => setCitationsDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ mt: 1, maxHeight: 300, overflowY: 'auto' }}>
            {citations.map((c, i) => (
              <Typography key={i} variant="body2" sx={{ mb: 1 }}>
                Citation-{i + 1}: {c.trim('#')}
              </Typography>
            ))}
          </Box>
        </Box>
      </Dialog>
      {/* Feedback Popup */}
      <Dialog open={feedbackDialogOpen} onClose={() => setFeedbackDialogOpen(false)}>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Feedback</Typography>
            <IconButton onClick={() => setFeedbackDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<ThumbUpAltOutlinedIcon />}
              onClick={() => {
                sendFeedback('thumbs_up');
                setFeedbackDialogOpen(false);
              }}
            >
              Thumbs Up
            </Button>
            <Button
              variant="outlined"
              startIcon={<ThumbDownAltOutlinedIcon />}
              onClick={() => {
                sendFeedback('thumbs_down');
                setFeedbackDialogOpen(false);
              }}
            >
              Thumbs Down
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
export default Chatbot;